module.exports = __webpack_public_path__ + "img/CF_2U.1.36cdb269.jpg";